import { render } from "./PropertySelectMultiple.vue?vue&type=template&id=5dd97f38"
import script from "./PropertySelectMultiple.vue?vue&type=script&lang=js"
export * from "./PropertySelectMultiple.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__